import * as React from "react";
import classNames from "classnames";
import css from "./medium-safe-pill.scss";
import { store } from "../../store";

export interface MediumSafePillProps {
    readonly mediumSafe: null | boolean | undefined;
    /** Sets a specific category of the medium safe pill translation keys. */
    readonly kind?: string;
}

export class MediumSafePill extends React.Component<MediumSafePillProps> {
    public render(): JSX.Element {
        return (
            <span
                className={classNames(css.mediumSafePill, {
                    [css["mediumSafePill--unsafe"]]: this.props.mediumSafe === false,
                    [css["mediumSafePill--safe"]]: this.props.mediumSafe === true,
                    [css["mediumSafePill--unknown"]]: this.props.mediumSafe === null,
                })}
            >
                {store.i18n.t(
                    `component.mediumSafePill.${this.props.kind ? this.props.kind : "default"}.${
                        this.props.mediumSafe ?? "unknown"
                    }`,
                )}
            </span>
        );
    }
}
